import { FetchWizardQry } from "api/queries";

export const wizardSideEffects = {
  queries: {},
  mutations: {
    topologyAction(result, _args, cache) {
      if (result.invokeTopologyAction) {
        const fetchWizardQueries = cache
          .inspectFields({ __typename: "Query" })
          .filter((item) => item.fieldName === "fetchWizard");
        if (fetchWizardQueries.length === 1) {
          cache.updateQuery(
            {
              query: FetchWizardQry,
              variables: fetchWizardQueries[0].arguments,
            },
            ({ fetchWizard }) => ({
              fetchWizard: {
                ...fetchWizard,
                topology: result.topologyAction.topology,
              },
            }),
          );
        } else {
          console.warn(
            "It shouldn't appear, but if it does some additional filtering should be added for wizardStepQuestionnaire query handler",
          );
        }
      }
    },
  },
};
